<template>
  <span />
</template>

<script>
import XlsxMixin from "../../../mixins/XlsxMixin.js";
import Catalog from "../StclCatalog.js";
import Info from "../StclInfo.js";
import Model from "../StclModel.js";
import StclItemCatalog from "../StclItemCatalog.js";

export default {
  mixins: [XlsxMixin],
  props: {
    userData: Object
  },
  created() {
    this.$emit(this.$kst.Enum.Event.Init, this.exportExcel);
  },
  methods: {
    exportExcel(data, fileName) {
      this.createBook();
      this.createSheet();

      this.addList(data.List);

      this.download(fileName);
    },

    addList(dataList) {
      // label
      this.addColumnHeader_ID();
      this.addColumnHeader(Catalog.ClosingNumber);
      this.addColumnHeader(Catalog.Date);
      this.addColumnHeader_ID(Catalog.WarehouseID.Label);
      this.addColumnHeader(Catalog.WarehouseID);
      this.addColumnHeader(Catalog.Total);

      if (this.userData.WithItems) {
        this.addColumnHeader_ID(StclItemCatalog.DispatchID.Label);
        this.addColumnHeader(StclItemCatalog.DispatchID);
        this.addColumnHeader(StclItemCatalog.Packaging);
        this.addColumnHeader(StclItemCatalog.Qty);
        this.addColumnHeader(StclItemCatalog.TotalQty);
        this.addColumnHeader(StclItemCatalog.SellPrice);
        this.addColumnHeader(StclItemCatalog.StockClosingItemsTotal);
      }

      // value
      for (const row of dataList) {
        this.addRow();

        this.addCellValue_ID(row);
        this.addCellValue("ClosingNumber", row, Catalog);
        this.addCellValue("Date", row, Catalog);
        this.addCellValue("WarehouseID", row, Catalog);
        this.addCellRelatedValue("WarehouseID", row, Catalog);
        this.addCellValue("Total", row, Catalog);

        if (this.userData.WithItems) {
          Model.updateItemReadOnly(row);

          this.addCellValue("DispatchID", row, StclItemCatalog);
          this.addCellRelatedValue("DispatchID", row, StclItemCatalog);
          this.addCellValue("Packaging", row, StclItemCatalog);
          this.addCellValue("Qty", row, StclItemCatalog);
          this.addCellValue("TotalQty", row, StclItemCatalog);
          this.addCellValue("SellPrice", row, StclItemCatalog);
          this.addCellValue("StockClosingItemsTotal", row, StclItemCatalog);
        }
      }

      this.addSheet(Info.Export.List.Excel.SheetName.List);
    }
  }
}
</script>